import { HospitalBoxIcon } from './HospitalBoxIcon';

/**
 * author: Google
 * id 83D0E9E7-B196-4515-A9C8-6E6FEB03ADD1
 * name hospital-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hospital-box.svg
 * tags
 * - Medical / Hospital 
 */
export const SwissCrossBoxIcon = HospitalBoxIcon;
export default SwissCrossBoxIcon